module.exports = __webpack_public_path__ + "static/media/md-infinite.23fe6eb0.svg";